import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Tick, Warning } from '../../helpers/icon-dictionary';
import css from './index.scss';
import Button from '../../components/button/index';
import messages from './delete-group-messages';
import ConfirmationMessage from '../confirmation-message/index';
import ConfirmationRequest from '../confirmation-request';
import withModal from '../with-modal';

const DeleteGroup = (props) => {
    const {
        handleOnManageStudentsBeforeDeleteGroup,
        intl,
        classTitle,
        selectedGroup,
        handleOnCloseDeleteGroupModal,
        isDeletingGroupInProgress,
        showDeleteNonEmptyGroupConfirmationModal,
        handleOnDeleteNonEmptyGroup,
        showDeleteGroupConfirmationBeforeSubmit,
        handleOnCancelDeleteGroupConfirmationBeforeSubmit,
        handleOnDeleteGroup,
        handleOnCloseDeleteGroupConfirmation,
        showDeleteGroupConfirmation
    } = props;

    const loadModalComponent = () => {
        let modalComponent = '';

        if (showDeleteNonEmptyGroupConfirmationModal) {
            modalComponent = (
                <ConfirmationMessage
                    handleOnCloseModal={handleOnDeleteNonEmptyGroup}
                    icon={Warning}>
                    <span className={css.highlight}>{selectedGroup.name} </span>
                    {intl.formatMessage(messages.deleteNonEmptyGroupConfirmation)}
                    <br />
                    {intl.formatMessage(messages.pleaseGoTo)}
                    <Button
                        buttonContainer={css.btnContainerStudentManagement}
                        containerClassName={css.btnStudentManagement}
                        handleOnClick={
                            () =>
                                handleOnManageStudentsBeforeDeleteGroup(selectedGroup.classroomId, classTitle, selectedGroup.id)
                        }
                        label={intl.formatMessage(messages.manageStudents)} />
                    {intl.formatMessage(messages.toMoveYourStudents)}
                </ConfirmationMessage>
            );
        }


        if (showDeleteGroupConfirmationBeforeSubmit) {
            modalComponent = (
                <ConfirmationRequest
                    handleOnCancel={handleOnCancelDeleteGroupConfirmationBeforeSubmit}
                    handleOnClose={handleOnCloseDeleteGroupModal}
                    handleOnOk={handleOnDeleteGroup}
                    isLoading={isDeletingGroupInProgress} >
                    {intl.formatMessage(messages.AreYouSureYouWantToDelete)}
                    <span className={css.highlight}> {selectedGroup.name} </span>
                    {intl.formatMessage(messages.questionMark)}
                </ConfirmationRequest>
            );
        }

        if (showDeleteGroupConfirmation) {
            modalComponent = (
                <ConfirmationMessage
                    handleOnCloseModal={handleOnCloseDeleteGroupConfirmation}
                    icon={Tick}>
                    {intl.formatMessage(messages.yourGroup)}
                    <span className={css.highlight}> {selectedGroup.name}</span>
                    {intl.formatMessage(messages.hasBeenDeleted)}
                </ConfirmationMessage>
            );
        }

        return modalComponent;
    };

    return loadModalComponent();
};

DeleteGroup.propTypes = {
    classTitle: PropTypes.string,
    handleOnCloseDeleteGroupConfirmation: PropTypes.func,
    handleOnCloseDeleteGroupModal: PropTypes.func,
    handleOnDeleteGroup: PropTypes.func,
    handleOnDeleteNonEmptyGroup: PropTypes.func,
    handleOnManageStudentsBeforeDeleteGroup: PropTypes.func,
    handleOnCancelDeleteGroupConfirmationBeforeSubmit: PropTypes.func,
    intl: intlShape.isRequired,
    isDeletingGroupInProgress: PropTypes.bool,
    selectedGroup: PropTypes.object,
    showDeleteNonEmptyGroupConfirmationModal: PropTypes.bool,
    showDeleteGroupConfirmation: PropTypes.bool,
    showDeleteGroupConfirmationBeforeSubmit: PropTypes.bool
};

const IntlDeleteGroup = injectIntl(DeleteGroup);
export default withModal('isActive')(IntlDeleteGroup);



// WEBPACK FOOTER //
// ./app/components/edit-class-form/delete-group.js